module.exports = __webpack_public_path__ + "static/TRAINING-0de27bfd1f6b1905131664ea7a1a4724.png";